<template>
  <customreport :report="2" />
</template>
<script>
import '@telexpress_auth/vue-customreport/dist/components/customreport.css';
import customreport from '@telexpress_auth/vue-customreport/dist/components/customreport.umd.min';

export default {
  components: {
    customreport,
  },
};
</script>
